<app-section
  [titleSection]="titleSection"
  [isLargeTitle]="true"
  [isActivable]="false"
  (cancled)="onCancelModal()"
>
  <div read-mode>
    <app-address-read-mode
      [propertyType]="propertyType"
      [addressInput]="addressInput"
    >
    </app-address-read-mode>
  </div>

  <div edit-mode>
    <app-address-edit-mode
      (addressChanged)="onAddressChanged($event)"
      [cancelModal]="cancelModal"
      [addressInput]="addressInput"
      [addressInputAutoCompletion]="addressInputAutoCompletion"
      (autocompletionSelected)="onAutocompletionSelected($event)"
      [autocompleteSelectedAddress]="autocompleteSelectedAddress"
      [geoInfoRead]="geoInfoRead"
    >
    </app-address-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Vous devez choisir une adresse valide"
      [loading]="isLoading"
      [disabled]="isLoading || !autocompleteSelectedAddress"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
